// extracted by mini-css-extract-plugin
module.exports = {"componentsCustomerService":"styles_componentsCustomerService__1Zksw","copyEmail":"styles_copyEmail__3_vbb"};